import React from "react";
import TableHead from "@mui/material/TableHead";
import StyledTableCell from "./StyledTableCell";
import TableRow from "@mui/material/TableRow";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FilterListIcon from "@mui/icons-material/FilterList";
import { StyledSortLabel } from "./styles";
import { useSelector } from "react-redux";

const Head = ({
    statusList,
    selectedStatuses,
    setSelectedStatuses,
    order,
    orderBy,
    onRequestSort,
}) => {
    const isAdmin = useSelector((state) => state.auth.isAdmin);

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    const StyledSortLabelWithProps = ({
        headCellId,
        "data-testid": dataTestId,
    }) => {
        return (
            <StyledSortLabel
                headCellId={headCellId}
                order={order}
                orderBy={orderBy}
                createSortHandler={createSortHandler}
                data-testid={dataTestId}
            />
        );
    };
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    return (
        <TableHead>
            <TableRow>
                <StyledTableCell>
                    <StyledSortLabelWithProps
                        headCellId={"index"}
                        data-testid={"sort-by-index"}
                    />
                    Index
                </StyledTableCell>
                <StyledTableCell>
                    <StyledSortLabelWithProps
                        headCellId={"commonName"}
                        data-testid={"sort-by-common-name"}
                    />
                    {"Common Name"}
                </StyledTableCell>
                <StyledTableCell>
                    <StyledSortLabelWithProps
                        headCellId={"serialNumber"}
                        data-testid={"sort-by-serial"}
                    />
                    Serial Number
                </StyledTableCell>
                <StyledTableCell align="center">
                    <StyledSortLabelWithProps
                        headCellId={"timeToExpire"}
                        data-testid={"sort-by-days-to-expire"}
                    />
                    Days to be expired
                </StyledTableCell>
                <StyledTableCell align="center">
                    <StyledSortLabelWithProps
                        headCellId={"status"}
                        data-testid={"sort-by-status"}
                    />
                    {"Status"}
                    <Tooltip title="Filter list">
                        <IconButton
                            style={{ color: "white" }}
                            onClick={handleClick}
                        >
                            <FilterListIcon />
                        </IconButton>
                    </Tooltip>
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                    >
                        <Typography>Select to filter.</Typography>

                        {statusList.map((status, index) => {
                            return (
                                <FormControlLabel
                                    key={index}
                                    checked={selectedStatuses.includes(status)}
                                    label={status}
                                    onChange={(event) => {
                                        if (selectedStatuses.includes(status)) {
                                            setSelectedStatuses((prevState) =>
                                                prevState.filter(
                                                    (item) => item !== status
                                                )
                                            );
                                        } else {
                                            setSelectedStatuses((prevState) => [
                                                ...prevState,
                                                status,
                                            ]);
                                        }
                                    }}
                                    control={
                                        <Checkbox
                                            data-testid={`filter-by-${status}`}
                                        />
                                    }
                                />
                            );
                        })}
                    </Popover>
                </StyledTableCell>
                {isAdmin && (
                    <StyledTableCell align="center">
                        private key
                    </StyledTableCell>
                )}
                <StyledTableCell align="center">Action</StyledTableCell>
            </TableRow>
        </TableHead>
    );
};
export default Head;
